__turbopack_context__.v({
  "newsContainer": "Ucr3wq_newsContainer",
});
